import React from 'react';

function SvgString(props) {
  const { image } = props;
  return (
    <div style={{ flex: 1 }}>
      <img src={`data:image/svg+xml;utf8,${encodeURIComponent(image)}`} />
    </div>
  );
}

export default SvgString;
